import "core-js/modules/es.array.push.js";
import { mapState } from 'vuex';
import axios from 'axios';
const CancelToken = axios.CancelToken;
export default {
  props: {
    info: Object,
    userInfo: Object,
    devicePlatform: {
      type: Object,
      default: function () {
        return {};
      }
    },
    userInfoParty: Boolean,
    data: {
      type: Array,
      default: function () {
        return [];
      }
    }
  },
  computed: {
    ...mapState({
      State: state => state,
      CurrentPartyInfo: state => state.currentPartyInfo,
      Config: state => state.config,
      tabConfig: state => state.tabConfig
    })
  },
  watch: {
    'CurrentPartyInfo.code': function (val) {
      if (val && this.userInfo.parentCode && val != this.userInfo.parentCode) {
        this.info.show = false;
      }
    }
  },
  data() {
    return {
      show: false,
      activeTab: 'party',
      activeTabName: 'Common Party',
      activeParty: '',
      activePartyName: '',
      tabList: [],
      partyList: [],
      moveInfo: {
        show: false,
        title: 'Movepips.moveTips.title',
        cancel: 'Movepips.moveTips.cancel',
        save: 'Movepips.moveTips.save'
      },
      scroll: {
        onScroll: this.scollMessage
      },
      queryParty: {
        party: '/partyline-backend/commonParty/page',
        group: '/partyline-backend/group/page',
        coordinator: '/partyline-backend/conference/page',
        kiosk: '/partyline-backend/kiosk/page'
      },
      strSplice: {
        party: 4,
        group: 4,
        coordinator: 3,
        arena: 3
      },
      params: {
        pageSize: 20,
        pageNum: 1
      },
      noMore: false,
      cancel: {},
      cancelLastTab: 'party',
      emailList: [],
      selectEmail: '',
      moveLoading: false
    };
  },
  created() {
    Object.keys(this.Config.mode).forEach(k => {
      if (this.Config.mode[k] && this.tabConfig[k]) {
        if (this.info.isIncludePack) {
          if (k === 'commonParty') {
            this.tabList.push(this.tabConfig[k]);
          }
        } else {
          this.tabList.push(this.tabConfig[k]);
          this.tabList = this.tabList.filter(item => {
            return item.name != 'globalControl' && item.name != 'interview';
          });
        }
      }
    });
    this.queryPartyList('party');
    this.getCollaborateList();
  },
  methods: {
    changeTab(val) {
      this.activeTabName = val.label;
      this.params.pageNum = 1;
      this.noMore = false;
      this.cancel[this.cancelLastTab] && this.cancel[this.cancelLastTab]();
      this.cancelLastTab = this.activeTab;
      this.queryPartyList(this.activeTab, this.selectEmail);
    },
    queryPartyList(key, userId) {
      this.moveLoading = true;
      const self = this;
      if (userId) {
        this.$set(this.params, 'collaborateUserId', userId);
      }
      this.axios.post(this.queryParty[key], this.params, {
        cancelToken: new CancelToken(function executor(c) {
          self.cancel[key] = c;
          // 这个参数 c 就是CancelToken构造函数里面自带的取消请求的函数，这里把该函数当参数用
        })
      }).then(res => {
        this.moveLoading = false;
        if (!res) return;
        let list = res.data.result.list;
        if (this.$route.name != 'globalControl') {
          list = list.filter(v => v.code != this.userInfo.joinCode);
        }
        if (this.params.pageNum == 1) {
          this.partyList = list;
        } else {
          this.partyList = this.partyList.concat(list);
        }
        if (!res.data.result.hasNextPage) {
          this.noMore = true;
        }
      }).catch(() => {
        this.moveLoading = false;
      });
    },
    getPartyList(userId) {
      this.moveLoading = true;
      const self = this;
      this.$set(this.params, 'collaborateUserId', userId);
      this.axios.post(this.queryParty[this.activeTab], this.params, {
        cancelToken: new CancelToken(function executor(c) {
          self.cancel.party = c;
          // 这个参数 c 就是CancelToken构造函数里面自带的取消请求的函数，这里把该函数当参数用
        })
      }).then(res => {
        this.moveLoading = false;
        if (!res) return;
        let list = res.data.result.list;
        list = list.filter(v => v.code != this.userInfo.joinCode);
        if (this.params.pageNum == 1) {
          this.partyList = list;
        } else {
          this.partyList = this.partyList.concat(list);
        }
        if (!res.data.result.hasNextPage) {
          this.noMore = true;
        }
      }).catch(() => {
        this.moveLoading = false;
      });
    },
    getCollaborateList() {
      this.axios.get('/partyline-backend/collaborate').then(res => {
        let {
          errorCode,
          result
        } = res.data;
        if (errorCode === '0x0') {
          result = result.filter(item => {
            return item.status == 1;
          });
          result.unshift({
            collaborateEmail: this.State.loginInfo.email,
            collaborateUserId: this.State.loginInfo.id
          });
          this.emailList = result;
          this.selectEmail = this.State.loginInfo.id;
        }
      });
    },
    selectParty(value) {
      this.activeParty = value.code;
      this.activePartyName = value.title || new Date(value.createTime).toLocaleDateString() + '   ' + new Date(value.createTime).toLocaleTimeString();
    },
    scollMessage() {
      if (this.moveLoading || this.noMore) return;
      this.params.pageNum += 1;
      this.queryPartyList(this.activeTab);
    },
    close() {
      this.info.show = false;
    },
    saveMove() {
      if (!this.activeParty) return;
      this.moveInfo.show = true;
      if (this.activeTabName === 'Common Party') {
        this.activeTabName = this.$t('commonFunction.commonParty');
      }
    },
    saveFn() {
      // 为了 Global Control 添加的
      if (this.userInfoParty) {
        for (const partyCode in this.info.partyInfo) {
          //  需要检查移动的里面是否有 tagger 如果有
          let hasTagger = false;
          if (this.info.partyInfo[partyCode].taggerRtilCode) {
            hasTagger = true;
            this.info.partyInfo[partyCode].rtilCodes = this.info.partyInfo[partyCode].rtilCodes.filter(rtilCode => {
              return rtilCode != this.info.partyInfo[partyCode].taggerRtilCode;
            });
          }
          const params = {
            originCode: partyCode,
            targetCode: this.activeParty,
            rtilCodes: this.info.partyInfo[partyCode].rtilCodes
          };
          this.axios.post(`/partyline-backend/partyAction/moveParticipants?partyCode=${this.userInfo.joinCode}&key=54767`, params, {
            errorTip: false
          }).then(res => {
            if (res.data.errorCode == '0x0') {
              this.$emit('callback');
              if (hasTagger) {
                this.$message.warning(this.$t('galleryHost.moveSuccessExpectTagger'));
              } else {
                this.$message.success(this.$t('galleryHost.movePartySuccess'));
              }
              this.info.show = false;
            } else {
              if (res.data.errorCode == '82201102') {
                this.$message.error(`Operation failed, currently only ${res.data.result} people can be moved to "${this.activePartyName}" of ${this.activeTabName}.`);
              } else {
                this.$message.error(this.$t('galleryHost.movePartyFailed'));
              }
            }
          });
        }
      } else {
        const params = {
          originCode: this.userInfo.parentCode,
          targetCode: this.activeParty,
          rtilCodes: this.info.rtilCodes
        };
        this.axios.post(`/partyline-backend/partyAction/moveParticipants?partyCode=${this.userInfo.joinCode}&key=54767`, params, {
          errorTip: false
        }).then(res => {
          if (res.data.errorCode == '0x0') {
            this.$emit('callback');
            this.$message.success(this.$t('galleryHost.movePartySuccess'));
            this.info.show = false;
          } else {
            if (res.data.errorCode == '82201102') {
              this.$message.error(`Operation failed, currently only ${res.data.result} people can be moved to "${this.activePartyName}" of ${this.activeTabName}.`);
            } else {
              this.$message.error(this.$t('galleryHost.movePartyFailed'));
            }
          }
        });
      }
    }
  }
};